/**
 * Analytics Hooks
 * ანალიტიკის ჰუკები
 */

import { useQuery } from '@tanstack/react-query';
import {
  getAnalyticsOverview,
  getAnalyticsTraffic,
  type StatisticsPeriod,
} from '../features/api/analytics';

export function useAnalyticsOverview() {
  const query = useQuery({
    queryKey: ['analytics', 'overview'],
    queryFn: getAnalyticsOverview,
    staleTime: 1000 * 60 * 5,
  });

  return {
    overview: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useAnalyticsTraffic(period: StatisticsPeriod = 'MONTH') {
  const query = useQuery({
    queryKey: ['analytics', 'traffic', period],
    queryFn: () => getAnalyticsTraffic(period),
    staleTime: 1000 * 60 * 5,
  });

  return {
    traffic: query.data,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
